<template>
  <div
    v-if="initdisplay"
  >
    <v-btn
      id="show-legend"
      class="control"
      :color="$store.state.displayLegendView? baseColor : undefined"
      small
      style="border-radius:10px; margin: 0.25em;width: 3em;"
      fab
      @click="toggleLegendCard()"
    >
      <v-icon> mdi-map-legend mdi-24px</v-icon>
    </v-btn>
  </div>
</template>

<script>

import { Mapable } from '../../mixins/Mapable';

export default {
  name: 'LegendControl',
  components: {
  },
  mixins: [Mapable],
  data() {
    return {
      initdisplay: this.$appConfig.showLegend,
      baseColor: this.$appConfig.baseColor,
      baseColorAccent: this.$appConfig.baseColorAccent,
      iconColor: this.$appConfig.iconColor,
      fab: false,
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    onMapBound() {
    },
    toggleLegendCard() {
      this.$store.commit('showLegendView');
    },
  },
};

</script>
<style scoped>
</style>
